import { MobileReleasesPage } from '@repo/ui/features/platform';

export default function SuperAdminMobileReleasesPage() {
  return (
    <div className="w-full py-6">
      <MobileReleasesPage />
    </div>
  );
}
